'use client';

import React, { useContext, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PhoneCall } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { PopupContext } from "@/context/PopupContext";
import Link from "next/link";

const phrases = [
    'Аванс уже сегодня',
    'Без комиссий',
    'До 90% от стоимости',
    'Без лишних показов',
];

export default function PromoBannerLoopText() {
    const [index, setIndex] = useState(0);
    const { openPopup } = useContext(PopupContext);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % phrases.length);
        }, 3500);
        return () => clearInterval(interval);
    }, []);

    return (
        <section
            className="max-w-custom mx-auto my-3 relative w-full bg-gradient-to-r from-orange-600 via-orange-500 to-orange-400 rounded-3xl overflow-hidden shadow-md p-8 sm:px-12 flex flex-col sm:flex-row items-start sm:items-center sm:justify-between text-white"
        >
            {/* Левая часть — заголовок + аним. текст */}
            <div className="flex flex-col gap-3 z-10 text-left">
                <p className="text-3xl sm:text-4xl lg:text-4xl font-black uppercase tracking-tight leading-tight drop-shadow-sm">
                    Продажа <br className="block sm:hidden"/>
                    за <span className="text-yellow-300">24 часа</span>
                </p>

                {/* Анимированный текст */}
                <div className="relative h-6 sm:h-8">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={phrases[index]}
                            initial={{ opacity: 0, y: 12 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -12 }}
                            transition={{ duration: 0.5 }}
                            className="text-sm sm:text-lg font-semibold text-white/90 px-1 py-0.5 border-b-2 border-yellow-300 w-fit drop-shadow-sm"
                        >
                            {phrases[index]}
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>

            {/* Иконка PhoneCall — только для мобилок и планшетов */}
            <Link className="absolute right-10 bottom-5 lg:hidden" href="tel:+79113007705">
                <div className="bg-white/20 border border-white/50 pl-6 rounded-full cursor-pointer">
                    <div className="flex flex-col items-center">
                        <div className="rounded-full p-3 bg-secondary hover:scale-105 transition-transform duration-300">
                            <PhoneCall size={18} color="white" />
                        </div>
                    </div>
                </div>
            </Link>

            {/* Кнопка на десктопе */}
            <div className="absolute right-10 bottom-5 hidden lg:block">
                <Button
                    onClick={() => openPopup('sell')}
                    className=" shadow-sm hover:shadow-lg border border-white text-white font-medium text-base px-6 py-3 rounded-full flex items-center gap-2 transition-all duration-300 hover:scale-100"
                >
                    <PhoneCall size={20} className="text-black" />
                    Продать быстро
                </Button>
            </div>
        </section>
    );
}
